<template>
  <div>
    <h1>Taxímetros No Asignados</h1>
    <b-row>
      <b-col md="6" class="my-1">
        <b-form-group label-cols-sm="3" label="Buscar" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Buscar taxímetro"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      show-empty
      stacked="md"
      :items="getNotAssignedTaximeters"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      empty-text="No existen registros por mostrar"
      emptyFilteredText="No existen registros por mostrar"
    >
    <template v-slot:cell(status)="row">
      <b-badge v-if="row.item.status" variant="success">Activo</b-badge>
      <b-badge v-else variant="warning">Inactivo</b-badge>
    </template>
      <template v-slot:cell(acciones)="row">
        <b-button @click="deleteTaximeter({id:row.item.id})" class="btn-sm" variant="outline-danger">Eliminar</b-button>
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div class="text-center" v-if="$apollo.queries.getNotAssignedTaximeters.loading">
        <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
    <AssignedTaximeters />
  </div>
</template>

<script>
import gql from 'graphql-tag'
import AssignedTaximeters from './tables/assignedTaximeters'
// import { encrypt } from '@/config/headers'
export default {
  components: {
    AssignedTaximeters,
  },
  data () {
    return {
      getNotAssignedTaximeters: [],
      fields: [
        { key: 'id', label: 'ID', sortable: true, sortDirection: 'desc' },
        { key: 'serialNumber', label: 'Número de Serie' },
        { key: 'status', label: 'Estatus' },
        { key: 'acciones', label: 'Acciones' },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      idDelete: null,
    }
  },
  apollo: {
    getNotAssignedTaximeters: {
      query: gql`query {
      getNotAssignedTaximeters {
          id
          serialNumber
          status
        }
      }`,
      context: {
        // headers: encrypt(new Date().getTime()),
      },
      error (erro) {
        console.log(erro)
      },
      skip() {
        return this.skipQuery
      },
      result ({ data, loading, networkStatus }) {
        if (data.getTaximeters) {
          this.totalRows = data.getNotAssignedTaximeters.length
        }
      },
    },
  },
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    async deleteTaximeter(id) {
      this.idDelete = id.id

      await this.$apollo.mutate({
        mutation: gql`mutation ($idDelete: Int) {
         deleteTaximeter(id:$idDelete){
          id
          serialNumber
          status
        }
        }`,
        context: {
          // headers: encrypt(new Date().getTime()),
        },
        variables: {
          idDelete: parseInt(this.idDelete),
        },
        update: (store, { data: { deleteTaximeter } }) => {
          const data = store.readQuery({
            query: gql`query {
                getNotAssignedTaximeters {
                  id
                  serialNumber
                  status
              }
              }`,
            context: {
              // headers: encrypt(new Date().getTime()),
            },
            error (erro) {
              console.log(erro)
            },
          })

          data.getTaximeters.pop(deleteTaximeter)
          store.writeQuery({
            query: gql`query {
                getNotAssignedTaximeters {
                  id
                  serialNumber
                  status
              }
              }`,
            context: {
              // headers: encrypt(new Date().getTime()),
            },
            error (erro) {
              console.log(erro)
            },
            data,
          })
        },
      })
        .then(res => {
          this.getTaximeters = this.getTaximeters.filter(item => item.id !== parseInt(this.idDelete))
        })
        .catch(error => {
          this.disabledButton = false
          this.error = error.message
        })
    },
  },
  created() {
    this.$apollo.queries.getNotAssignedTaximeters.skip = false
  },
}
</script>

<style>

</style>
